import { Attrs, MinzeElement } from 'minze'

export class LvcFlagIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', '28'],
    ['height', '28'],
    ['stroke-color', '#1E007D'],
  ]
  html = () => `
    <svg width="${this.width}" height="${this.height}" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.82281 6.17952C8.83578 9.06166 8.95883 11.7772 8.82262 14.653C8.69118 17.4277 8.50821 20.1898 8.43652 22.9677" stroke="${this.strokeColor}" stroke-width="1.35" stroke-linecap="round"/>
      <path d="M9.27159 14.0173C10.9976 14.1476 12.7707 14.7315 14.3837 15.4184C15.4126 15.8565 16.3889 16.0407 17.4921 15.9925C18.3667 15.9543 19.2284 15.8064 20.1055 15.8011C20.5611 15.7984 21.0169 15.8011 21.4725 15.8011C21.804 15.8011 21.55 15.7241 21.3729 15.6166C20.4172 15.0362 19.6721 14.104 18.8169 13.3645C18.6545 13.2241 18.1107 12.9306 17.987 12.705C17.9705 12.6749 17.9909 12.6295 18.0111 12.6025C18.1619 12.4007 18.3811 12.2802 18.5694 12.124C19.7943 11.108 20.9343 10.087 21.898 8.75451C21.995 8.62047 22.06 8.60415 21.9161 8.60415C21.6525 8.60415 21.389 8.60469 21.1255 8.59048C20.1875 8.5399 19.2521 8.46152 18.3129 8.43328C17.759 8.41663 17.1535 8.34967 16.6018 8.45379C16.1266 8.54347 15.6669 8.7577 15.1834 8.78527C14.0414 8.8504 13.1148 8.05919 12.2562 7.31239C11.601 6.74247 10.8779 6.06853 10.017 6.00354C9.67168 5.97747 8.50012 5.99997 8.99999 6.14365" stroke="${this.strokeColor}" stroke-width="1.35" stroke-linecap="round"/>
    </svg>
  `
  css = () => `
    :host {
      width: ${this.width}px;
      height: ${this.height}px;
    }
  `
}
